module.exports = __webpack_public_path__ + "media/images/png/no-money-e88cedbb7f30c86a296c0dd2774e21fe.png";